module.exports = __webpack_public_path__ + "img/71.e451b520.png";